import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setReady, setShowExperience} from "../store/reducers/questionReducer";
import {Stream} from "./Stream";


interface IProps {
    stream: any;
    sendDataToSocket: (data: any) => void;
}

export const Launch = (props: IProps) => {
    const {
        stream,
        sendDataToSocket
    } = props;
    const dispatch = useDispatch();
    //const {permissionState, requestMicrophone} = useMicrophonePermission();

    const [loading, setLoading] = React.useState<boolean>(true);
    const streamData = useSelector((state: any) => state.questionReducer.streamData);
    const showExperience = useSelector((state: any) => state.questionReducer.showExperience);
    const streamDataRef = React.useRef(streamData);
    const ready = useSelector((state: any) => state.questionReducer.ready);

    React.useEffect(() => {
        streamDataRef.current = streamData;
    }, [streamData])

    React.useEffect(() => {
        if (window.chatOnly) {
            dispatch(setReady(true));
            setLoading(false)
        } else {
            if (streamDataRef.current.streamUrl !== '' && ready === true) {
                setTimeout(() => {
                    setLoading(false)
                }, 1200)
            }
        }

    }, [streamData, ready])

    function enterExperience() {
        /*if (permissionState !== 'granted') {
            requestMicrophone()
        }*/
        dispatch(setShowExperience(true))
    }

    return (
        <div className="tc-launch-wrapper tc-chat-wrapper">

            <div className="tc-chat-container">
                <Stream loading={loading} stream={stream} enterExperience={enterExperience}
                        sendDataToSocket={sendDataToSocket}/>
                {/*<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 194 78">
                    <g>
                        <polygon className="cls-1"
                                 points="89.87 .53 89.87 22.15 89.87 22.15 97.89 30.17 97.89 30.17 97.99 30.32 103.37 24.94 103.37 24.89 103.42 24.89 103.42 14.03 98.9 14.03 98.9 23.06 97.99 23.93 94.38 20.32 94.38 .53 89.87 .53"/>
                        <polygon className="cls-1"
                                 points="85.4 9.57 80.88 9.57 80.88 25.86 89.31 34.23 89.31 52.09 93.77 52.09 93.77 32.4 85.4 23.98 85.4 9.57"/>
                    </g>
                    <g>
                        <polygon className="cls-2"
                                 points="30.69 32.3 26.74 42.91 22.73 32.3 17.65 32.3 14.25 52.19 19.38 52.19 21.1 40.73 25.57 52.19 27.65 52.19 32.32 40.73 34.04 52.19 39.17 52.19 35.82 32.3 30.69 32.3"/>
                        <path className="cls-2"
                              d="m54.95,44.79l-2.33-6.65-2.33,6.65h4.67Zm1.37,3.91h-7.36l-1.17,3.45h-5.53l7.56-19.89h5.63l7.56,19.89h-5.48l-1.22-3.45Z"/>
                        <path className="cls-2"
                              d="m72.36,41.18h.96c1.01,0,1.83-.2,2.33-.61.56-.41.81-1.01.81-1.83s-.25-1.42-.81-1.83c-.56-.41-1.32-.61-2.33-.61h-.96v4.87Zm11.37,11.01h-6.45l-4.92-7.66v7.66h-5.18v-19.89h8.07c1.12,0,2.08.15,2.89.51.81.3,1.52.76,2.03,1.32.56.56.96,1.22,1.22,1.93.25.76.41,1.52.41,2.39,0,1.52-.36,2.74-1.12,3.7-.71.96-1.83,1.57-3.25,1.93l6.29,8.12Z"/>
                        <path className="cls-2"
                              d="m114.99,38.8c-1.22-1.47-2.69-2.18-4.42-2.18-.76,0-1.47.15-2.13.41-.66.3-1.22.66-1.73,1.17-.46.51-.86,1.07-1.12,1.73s-.41,1.37-.41,2.18.15,1.52.41,2.18.66,1.27,1.12,1.73c.51.51,1.07.86,1.73,1.17.66.3,1.37.41,2.13.41,1.67,0,3.15-.71,4.47-2.13v6.14l-.51.2c-.81.3-1.52.51-2.23.61-.71.15-1.37.2-2.03.2-1.37,0-2.69-.25-3.96-.76s-2.39-1.27-3.35-2.18c-.96-.96-1.73-2.08-2.33-3.35-.56-1.27-.86-2.69-.86-4.21s.3-2.94.86-4.21c.56-1.27,1.32-2.39,2.28-3.3s2.08-1.62,3.35-2.18c1.27-.51,2.59-.76,4.01-.76.81,0,1.57.1,2.33.25s1.57.41,2.44.76v6.14h-.05Z"/>
                        <path className="cls-2"
                              d="m124.93,42.1c0,.81.15,1.52.46,2.18.3.66.71,1.27,1.22,1.73.51.51,1.12.86,1.78,1.17.66.25,1.37.41,2.13.41s1.47-.15,2.13-.41,1.27-.66,1.78-1.17.91-1.07,1.22-1.73c.3-.66.46-1.42.46-2.18s-.15-1.52-.46-2.18c-.3-.66-.71-1.27-1.22-1.73-.51-.51-1.12-.86-1.78-1.17-.66-.25-1.37-.41-2.13-.41s-1.47.15-2.13.41-1.27.66-1.78,1.17-.91,1.07-1.22,1.73c-.3.66-.46,1.42-.46,2.18m-5.43,0c0-1.47.25-2.84.81-4.11s1.32-2.39,2.28-3.35,2.13-1.67,3.45-2.23c1.37-.56,2.84-.81,4.47-.81s3.1.25,4.42.81c1.37.56,2.54,1.27,3.5,2.23s1.73,2.08,2.28,3.35.81,2.64.81,4.11-.25,2.84-.81,4.11-1.32,2.39-2.28,3.35-2.13,1.67-3.5,2.23-2.84.81-4.42.81-3.1-.25-4.47-.81-2.49-1.27-3.45-2.23c-.96-.96-1.73-2.08-2.28-3.35-.51-1.27-.81-2.64-.81-4.11"/>
                        <path className="cls-2"
                              d="m151.12,41.28h1.73c1.88,0,2.84-.81,2.84-2.49s-.96-2.49-2.84-2.49h-1.73v4.97Zm0,10.76h-5.18v-19.89h8.22c2.23,0,3.96.56,5.13,1.73,1.17,1.17,1.78,2.79,1.78,4.92s-.61,3.76-1.78,4.92c-1.17,1.17-2.89,1.73-5.13,1.73h-3.04v6.6Z"/>
                        <path className="cls-2"
                              d="m171.83,38.04l2.33,6.6h-4.67l2.33-6.6Zm-2.79-5.89l-7.56,19.89h5.53l1.17-3.45h7.41l1.17,3.45h5.53l-7.56-19.89h-5.68Z"/>
                        <path className="cls-2"
                              d="m56.32,65.8c-1.01-1.22-2.28-1.88-3.76-1.88-.66,0-1.27.1-1.83.36s-1.01.56-1.42.96c-.41.41-.71.91-.96,1.47-.25.56-.36,1.17-.36,1.83s.1,1.27.36,1.88c.25.56.56,1.07.96,1.47.41.41.91.76,1.42.96.56.25,1.17.36,1.78.36,1.42,0,2.64-.61,3.76-1.78v5.18l-.46.15c-.66.25-1.32.41-1.88.51s-1.17.15-1.73.15c-1.17,0-2.28-.2-3.35-.66-1.07-.46-1.98-1.07-2.79-1.88-.81-.81-1.47-1.73-1.98-2.84-.51-1.12-.76-2.28-.76-3.6s.25-2.49.71-3.55c.51-1.07,1.12-2.03,1.93-2.79.81-.76,1.78-1.37,2.84-1.83s2.18-.66,3.35-.66c.66,0,1.32.05,1.98.2s1.32.36,2.03.66v5.33h.15Z"/>
                        <path className="cls-2"
                              d="m64.34,68.59c0,.66.1,1.27.36,1.88.25.56.61,1.07,1.01,1.47.46.41.91.76,1.52.96.56.25,1.17.36,1.83.36s1.27-.1,1.83-.36,1.07-.56,1.52-.96.76-.91,1.01-1.47c.25-.56.36-1.17.36-1.88,0-.66-.15-1.27-.36-1.88-.25-.56-.61-1.07-1.01-1.47-.46-.41-.96-.76-1.52-.96-.56-.25-1.17-.36-1.83-.36s-1.27.1-1.83.36-1.07.56-1.52.96c-.46.41-.76.91-1.01,1.47-.25.56-.36,1.17-.36,1.88m-4.62,0c0-1.27.25-2.44.71-3.5.46-1.07,1.12-2.03,1.93-2.84.81-.81,1.78-1.42,2.94-1.88,1.12-.46,2.39-.66,3.76-.66s2.59.2,3.76.66,2.13,1.07,2.94,1.88,1.47,1.73,1.93,2.84.71,2.23.71,3.5-.25,2.44-.71,3.5c-.46,1.07-1.12,2.03-1.93,2.84-.81.81-1.83,1.42-2.94,1.88-1.17.46-2.39.66-3.76.66s-2.64-.2-3.76-.66c-1.12-.46-2.13-1.07-2.94-1.88-.81-.81-1.47-1.73-1.93-2.84-.46-1.12-.71-2.28-.71-3.5"/>
                        <path className="cls-2"
                              d="m86.42,60.16v9.13c0,.51,0,1.01.05,1.52s.15.96.36,1.42c.2.41.46.76.86,1.01s.96.41,1.67.41,1.27-.15,1.67-.41.71-.61.86-1.01c.2-.41.3-.86.36-1.42.05-.51.05-1.01.05-1.52v-9.13h4.36v9.74c0,2.64-.61,4.52-1.78,5.73-1.22,1.22-3.04,1.83-5.53,1.83s-4.31-.61-5.53-1.83c-1.22-1.22-1.83-3.1-1.83-5.73v-9.74h4.42Z"/>
                        <polygon className="cls-2"
                                 points="114.07 60.16 114.07 70.46 106.01 60.16 101.59 60.16 101.59 77.01 106.01 77.01 106.01 66.71 114.07 77.01 118.44 77.01 118.44 60.16 114.07 60.16"/>
                        <polygon className="cls-2"
                                 points="121.28 60.16 121.28 63.87 124.88 63.87 124.88 77.01 129.25 77.01 129.25 63.87 132.85 63.87 132.85 60.16 121.28 60.16"/>
                        <polygon className="cls-2"
                                 points="146.6 60.16 143.51 64.73 140.36 60.16 135.14 60.16 141.28 68.89 141.28 77.01 145.64 77.01 145.64 68.89 151.83 60.16 146.6 60.16"/>
                    </g>
                </svg>*/}
                {/* {showExperience === false &&
                    <div className='launch-btn-wrapper'><a href="#" className="tc-launch-enter-btn"
                                                           onClick={enterExperience}>Chat
                        with {(window as any).name}</a></div>} */}
            </div>

        </div>
    );
}
